/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Machine_Translation_NameInputs */



/**
* | output |
* | --- |
* | "MT \| {language}" |
*
* @param {Machine_Translation_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const machine_translation_name = /** @type {((inputs: Machine_Translation_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Machine_Translation_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (` MT | ${i?.language}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`МТ | ${i?.language}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	if (locale === "hi") return /** @type {LocalizedString} */ ("एमटी | __पीएच_0__")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`MT | ${i?.language}`)
	return /** @type {LocalizedString} */ (` MT | ${i?.language}`)
});